/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AuthLayoutRouteImport } from './routes/_authLayout';
import { Route as IndexRouteImport } from './routes/index';
import { Route as SignUpSplatRouteImport } from './routes/sign-up.$';
import { Route as SignInSplatRouteImport } from './routes/sign-in.$';
import { Route as AuthLayoutUserRouteImport } from './routes/_authLayout/user';
import { Route as AuthLayoutSignInRouteImport } from './routes/_authLayout/sign-in';
import { Route as AuthLayoutSettingsMemberRouteImport } from './routes/_authLayout/settings-member';
import { Route as AuthLayoutSettingsRouteImport } from './routes/_authLayout/settings';
import { Route as AuthLayoutPortfoliosRouteImport } from './routes/_authLayout/portfolios';
import { Route as AuthLayoutPfolioSettingsRouteImport } from './routes/_authLayout/pfolio-settings';
import { Route as AuthLayoutOnLoggedRouteImport } from './routes/_authLayout/on-logged';
import { Route as AuthLayoutObligationsRouteImport } from './routes/_authLayout/obligations';
import { Route as AuthLayoutNoPortfoliosRouteImport } from './routes/_authLayout/no-portfolios';
import { Route as AuthLayoutNoDashboardsRouteImport } from './routes/_authLayout/no-dashboards';
import { Route as AuthLayoutDocumentsRouteImport } from './routes/_authLayout/documents';
import { Route as AuthLayoutAnalyticsRouteImport } from './routes/_authLayout/analytics';
import { Route as AuthLayoutWorkflowsIndexRouteImport } from './routes/_authLayout/workflows.index';
import { Route as AuthLayoutWorkflowsWorkflowIdRouteImport } from './routes/_authLayout/workflows.$workflowId';
import { Route as AuthLayoutPortfolioCreateRouteImport } from './routes/_authLayout/portfolio.create';
import { Route as AuthLayoutPortfolioCompanyPortfolioIdRouteImport } from './routes/_authLayout/portfolio-company.$portfolioId';
import { Route as AuthLayoutPopoutWidgetTypeRouteImport } from './routes/_authLayout/popout.$widgetType';
import { Route as AuthLayoutFundOverviewRouteImport } from './routes/_authLayout/fund.overview';
import { Route as AuthLayoutDocumentsFundCreateRouteImport } from './routes/_authLayout/documents.fund-create';
import { Route as AuthLayoutDebugWidgetRouteImport } from './routes/_authLayout/debug.widget';
import { Route as AuthLayoutDebugForwardReturnsRouteImport } from './routes/_authLayout/debug.forward-returns';
import { Route as AuthLayoutDebugAssetBreakdownRouteImport } from './routes/_authLayout/debug.asset-breakdown';
import { Route as AuthLayoutDashboardDashboardIdRouteImport } from './routes/_authLayout/dashboard.$dashboardId';
import { Route as AuthLayoutCompanyListRouteImport } from './routes/_authLayout/company.list';
import { Route as AuthLayoutCompanyCompanyIdRouteImport } from './routes/_authLayout/company.$companyId';
import { Route as AuthLayoutAnalyticsUploadRouteImport } from './routes/_authLayout/analytics.upload';
import { Route as AuthLayoutAnalyticsFundIdRouteImport } from './routes/_authLayout/analytics.$fundId';
import { Route as AuthLayoutPortfolioPortfolioIdUploadRouteImport } from './routes/_authLayout/portfolio.$portfolioId.upload';
import { Route as AuthLayoutPortfolioPortfolioIdRisksRouteImport } from './routes/_authLayout/portfolio.$portfolioId.risks';
import { Route as AuthLayoutPortfolioPortfolioIdOverviewRouteImport } from './routes/_authLayout/portfolio.$portfolioId.overview';
import { Route as AuthLayoutPortfolioPortfolioIdAnalysisRouteImport } from './routes/_authLayout/portfolio.$portfolioId.analysis';
import { Route as AuthLayoutPortfolioPortfolioIdAiRecommendationsRouteImport } from './routes/_authLayout/portfolio.$portfolioId.ai-recommendations';
import { Route as AuthLayoutObligationsListCountryCodeRouteImport } from './routes/_authLayout/obligations.list.$countryCode';
import { Route as AuthLayoutFundPortfolioCompaniesFundIdRouteImport } from './routes/_authLayout/fund.portfolioCompanies.$fundId';
import { Route as AuthLayoutDocumentsOverviewDocIdRouteImport } from './routes/_authLayout/documents.overview.$docId';
import { Route as AuthLayoutDocumentsFundFundIdRouteImport } from './routes/_authLayout/documents.fund.$fundId';
import { Route as AuthLayoutObligationsClauseDocumentIdClauseIdRouteImport } from './routes/_authLayout/obligations.clause.$documentId.$clauseId';

const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_authLayout',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const SignUpSplatRoute = SignUpSplatRouteImport.update({
  id: '/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => rootRouteImport,
} as any);
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthLayoutUserRoute = AuthLayoutUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutSignInRoute = AuthLayoutSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutSettingsMemberRoute =
  AuthLayoutSettingsMemberRouteImport.update({
    id: '/settings-member',
    path: '/settings-member',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutSettingsRoute = AuthLayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutPortfoliosRoute = AuthLayoutPortfoliosRouteImport.update({
  id: '/portfolios',
  path: '/portfolios',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutPfolioSettingsRoute =
  AuthLayoutPfolioSettingsRouteImport.update({
    id: '/pfolio-settings',
    path: '/pfolio-settings',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutOnLoggedRoute = AuthLayoutOnLoggedRouteImport.update({
  id: '/on-logged',
  path: '/on-logged',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutObligationsRoute = AuthLayoutObligationsRouteImport.update({
  id: '/obligations',
  path: '/obligations',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutNoPortfoliosRoute = AuthLayoutNoPortfoliosRouteImport.update({
  id: '/no-portfolios',
  path: '/no-portfolios',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutNoDashboardsRoute = AuthLayoutNoDashboardsRouteImport.update({
  id: '/no-dashboards',
  path: '/no-dashboards',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutDocumentsRoute = AuthLayoutDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutAnalyticsRoute = AuthLayoutAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutWorkflowsIndexRoute =
  AuthLayoutWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutWorkflowsWorkflowIdRoute =
  AuthLayoutWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutPortfolioCreateRoute =
  AuthLayoutPortfolioCreateRouteImport.update({
    id: '/portfolio/create',
    path: '/portfolio/create',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutPortfolioCompanyPortfolioIdRoute =
  AuthLayoutPortfolioCompanyPortfolioIdRouteImport.update({
    id: '/portfolio-company/$portfolioId',
    path: '/portfolio-company/$portfolioId',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutPopoutWidgetTypeRoute =
  AuthLayoutPopoutWidgetTypeRouteImport.update({
    id: '/popout/$widgetType',
    path: '/popout/$widgetType',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutFundOverviewRoute = AuthLayoutFundOverviewRouteImport.update({
  id: '/fund/overview',
  path: '/fund/overview',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutDocumentsFundCreateRoute =
  AuthLayoutDocumentsFundCreateRouteImport.update({
    id: '/fund-create',
    path: '/fund-create',
    getParentRoute: () => AuthLayoutDocumentsRoute,
  } as any);
const AuthLayoutDebugWidgetRoute = AuthLayoutDebugWidgetRouteImport.update({
  id: '/debug/widget',
  path: '/debug/widget',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutDebugForwardReturnsRoute =
  AuthLayoutDebugForwardReturnsRouteImport.update({
    id: '/debug/forward-returns',
    path: '/debug/forward-returns',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutDebugAssetBreakdownRoute =
  AuthLayoutDebugAssetBreakdownRouteImport.update({
    id: '/debug/asset-breakdown',
    path: '/debug/asset-breakdown',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutDashboardDashboardIdRoute =
  AuthLayoutDashboardDashboardIdRouteImport.update({
    id: '/dashboard/$dashboardId',
    path: '/dashboard/$dashboardId',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutCompanyListRoute = AuthLayoutCompanyListRouteImport.update({
  id: '/company/list',
  path: '/company/list',
  getParentRoute: () => AuthLayoutRoute,
} as any);
const AuthLayoutCompanyCompanyIdRoute =
  AuthLayoutCompanyCompanyIdRouteImport.update({
    id: '/company/$companyId',
    path: '/company/$companyId',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutAnalyticsUploadRoute =
  AuthLayoutAnalyticsUploadRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => AuthLayoutAnalyticsRoute,
  } as any);
const AuthLayoutAnalyticsFundIdRoute =
  AuthLayoutAnalyticsFundIdRouteImport.update({
    id: '/$fundId',
    path: '/$fundId',
    getParentRoute: () => AuthLayoutAnalyticsRoute,
  } as any);
const AuthLayoutPortfolioPortfolioIdUploadRoute =
  AuthLayoutPortfolioPortfolioIdUploadRouteImport.update({
    id: '/portfolio/$portfolioId/upload',
    path: '/portfolio/$portfolioId/upload',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutPortfolioPortfolioIdRisksRoute =
  AuthLayoutPortfolioPortfolioIdRisksRouteImport.update({
    id: '/portfolio/$portfolioId/risks',
    path: '/portfolio/$portfolioId/risks',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutPortfolioPortfolioIdOverviewRoute =
  AuthLayoutPortfolioPortfolioIdOverviewRouteImport.update({
    id: '/portfolio/$portfolioId/overview',
    path: '/portfolio/$portfolioId/overview',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutPortfolioPortfolioIdAnalysisRoute =
  AuthLayoutPortfolioPortfolioIdAnalysisRouteImport.update({
    id: '/portfolio/$portfolioId/analysis',
    path: '/portfolio/$portfolioId/analysis',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute =
  AuthLayoutPortfolioPortfolioIdAiRecommendationsRouteImport.update({
    id: '/portfolio/$portfolioId/ai-recommendations',
    path: '/portfolio/$portfolioId/ai-recommendations',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutObligationsListCountryCodeRoute =
  AuthLayoutObligationsListCountryCodeRouteImport.update({
    id: '/list/$countryCode',
    path: '/list/$countryCode',
    getParentRoute: () => AuthLayoutObligationsRoute,
  } as any);
const AuthLayoutFundPortfolioCompaniesFundIdRoute =
  AuthLayoutFundPortfolioCompaniesFundIdRouteImport.update({
    id: '/fund/portfolioCompanies/$fundId',
    path: '/fund/portfolioCompanies/$fundId',
    getParentRoute: () => AuthLayoutRoute,
  } as any);
const AuthLayoutDocumentsOverviewDocIdRoute =
  AuthLayoutDocumentsOverviewDocIdRouteImport.update({
    id: '/overview/$docId',
    path: '/overview/$docId',
    getParentRoute: () => AuthLayoutDocumentsRoute,
  } as any);
const AuthLayoutDocumentsFundFundIdRoute =
  AuthLayoutDocumentsFundFundIdRouteImport.update({
    id: '/fund/$fundId',
    path: '/fund/$fundId',
    getParentRoute: () => AuthLayoutDocumentsRoute,
  } as any);
const AuthLayoutObligationsClauseDocumentIdClauseIdRoute =
  AuthLayoutObligationsClauseDocumentIdClauseIdRouteImport.update({
    id: '/clause/$documentId/$clauseId',
    path: '/clause/$documentId/$clauseId',
    getParentRoute: () => AuthLayoutObligationsRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/analytics': typeof AuthLayoutAnalyticsRouteWithChildren;
  '/documents': typeof AuthLayoutDocumentsRouteWithChildren;
  '/no-dashboards': typeof AuthLayoutNoDashboardsRoute;
  '/no-portfolios': typeof AuthLayoutNoPortfoliosRoute;
  '/obligations': typeof AuthLayoutObligationsRouteWithChildren;
  '/on-logged': typeof AuthLayoutOnLoggedRoute;
  '/pfolio-settings': typeof AuthLayoutPfolioSettingsRoute;
  '/portfolios': typeof AuthLayoutPortfoliosRoute;
  '/settings': typeof AuthLayoutSettingsRoute;
  '/settings-member': typeof AuthLayoutSettingsMemberRoute;
  '/sign-in': typeof AuthLayoutSignInRoute;
  '/user': typeof AuthLayoutUserRoute;
  '/sign-in/$': typeof SignInSplatRoute;
  '/sign-up/$': typeof SignUpSplatRoute;
  '/analytics/$fundId': typeof AuthLayoutAnalyticsFundIdRoute;
  '/analytics/upload': typeof AuthLayoutAnalyticsUploadRoute;
  '/company/$companyId': typeof AuthLayoutCompanyCompanyIdRoute;
  '/company/list': typeof AuthLayoutCompanyListRoute;
  '/dashboard/$dashboardId': typeof AuthLayoutDashboardDashboardIdRoute;
  '/debug/asset-breakdown': typeof AuthLayoutDebugAssetBreakdownRoute;
  '/debug/forward-returns': typeof AuthLayoutDebugForwardReturnsRoute;
  '/debug/widget': typeof AuthLayoutDebugWidgetRoute;
  '/documents/fund-create': typeof AuthLayoutDocumentsFundCreateRoute;
  '/fund/overview': typeof AuthLayoutFundOverviewRoute;
  '/popout/$widgetType': typeof AuthLayoutPopoutWidgetTypeRoute;
  '/portfolio-company/$portfolioId': typeof AuthLayoutPortfolioCompanyPortfolioIdRoute;
  '/portfolio/create': typeof AuthLayoutPortfolioCreateRoute;
  '/workflows/$workflowId': typeof AuthLayoutWorkflowsWorkflowIdRoute;
  '/workflows/': typeof AuthLayoutWorkflowsIndexRoute;
  '/documents/fund/$fundId': typeof AuthLayoutDocumentsFundFundIdRoute;
  '/documents/overview/$docId': typeof AuthLayoutDocumentsOverviewDocIdRoute;
  '/fund/portfolioCompanies/$fundId': typeof AuthLayoutFundPortfolioCompaniesFundIdRoute;
  '/obligations/list/$countryCode': typeof AuthLayoutObligationsListCountryCodeRoute;
  '/portfolio/$portfolioId/ai-recommendations': typeof AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute;
  '/portfolio/$portfolioId/analysis': typeof AuthLayoutPortfolioPortfolioIdAnalysisRoute;
  '/portfolio/$portfolioId/overview': typeof AuthLayoutPortfolioPortfolioIdOverviewRoute;
  '/portfolio/$portfolioId/risks': typeof AuthLayoutPortfolioPortfolioIdRisksRoute;
  '/portfolio/$portfolioId/upload': typeof AuthLayoutPortfolioPortfolioIdUploadRoute;
  '/obligations/clause/$documentId/$clauseId': typeof AuthLayoutObligationsClauseDocumentIdClauseIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/analytics': typeof AuthLayoutAnalyticsRouteWithChildren;
  '/documents': typeof AuthLayoutDocumentsRouteWithChildren;
  '/no-dashboards': typeof AuthLayoutNoDashboardsRoute;
  '/no-portfolios': typeof AuthLayoutNoPortfoliosRoute;
  '/obligations': typeof AuthLayoutObligationsRouteWithChildren;
  '/on-logged': typeof AuthLayoutOnLoggedRoute;
  '/pfolio-settings': typeof AuthLayoutPfolioSettingsRoute;
  '/portfolios': typeof AuthLayoutPortfoliosRoute;
  '/settings': typeof AuthLayoutSettingsRoute;
  '/settings-member': typeof AuthLayoutSettingsMemberRoute;
  '/sign-in': typeof AuthLayoutSignInRoute;
  '/user': typeof AuthLayoutUserRoute;
  '/sign-in/$': typeof SignInSplatRoute;
  '/sign-up/$': typeof SignUpSplatRoute;
  '/analytics/$fundId': typeof AuthLayoutAnalyticsFundIdRoute;
  '/analytics/upload': typeof AuthLayoutAnalyticsUploadRoute;
  '/company/$companyId': typeof AuthLayoutCompanyCompanyIdRoute;
  '/company/list': typeof AuthLayoutCompanyListRoute;
  '/dashboard/$dashboardId': typeof AuthLayoutDashboardDashboardIdRoute;
  '/debug/asset-breakdown': typeof AuthLayoutDebugAssetBreakdownRoute;
  '/debug/forward-returns': typeof AuthLayoutDebugForwardReturnsRoute;
  '/debug/widget': typeof AuthLayoutDebugWidgetRoute;
  '/documents/fund-create': typeof AuthLayoutDocumentsFundCreateRoute;
  '/fund/overview': typeof AuthLayoutFundOverviewRoute;
  '/popout/$widgetType': typeof AuthLayoutPopoutWidgetTypeRoute;
  '/portfolio-company/$portfolioId': typeof AuthLayoutPortfolioCompanyPortfolioIdRoute;
  '/portfolio/create': typeof AuthLayoutPortfolioCreateRoute;
  '/workflows/$workflowId': typeof AuthLayoutWorkflowsWorkflowIdRoute;
  '/workflows': typeof AuthLayoutWorkflowsIndexRoute;
  '/documents/fund/$fundId': typeof AuthLayoutDocumentsFundFundIdRoute;
  '/documents/overview/$docId': typeof AuthLayoutDocumentsOverviewDocIdRoute;
  '/fund/portfolioCompanies/$fundId': typeof AuthLayoutFundPortfolioCompaniesFundIdRoute;
  '/obligations/list/$countryCode': typeof AuthLayoutObligationsListCountryCodeRoute;
  '/portfolio/$portfolioId/ai-recommendations': typeof AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute;
  '/portfolio/$portfolioId/analysis': typeof AuthLayoutPortfolioPortfolioIdAnalysisRoute;
  '/portfolio/$portfolioId/overview': typeof AuthLayoutPortfolioPortfolioIdOverviewRoute;
  '/portfolio/$portfolioId/risks': typeof AuthLayoutPortfolioPortfolioIdRisksRoute;
  '/portfolio/$portfolioId/upload': typeof AuthLayoutPortfolioPortfolioIdUploadRoute;
  '/obligations/clause/$documentId/$clauseId': typeof AuthLayoutObligationsClauseDocumentIdClauseIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_authLayout': typeof AuthLayoutRouteWithChildren;
  '/_authLayout/analytics': typeof AuthLayoutAnalyticsRouteWithChildren;
  '/_authLayout/documents': typeof AuthLayoutDocumentsRouteWithChildren;
  '/_authLayout/no-dashboards': typeof AuthLayoutNoDashboardsRoute;
  '/_authLayout/no-portfolios': typeof AuthLayoutNoPortfoliosRoute;
  '/_authLayout/obligations': typeof AuthLayoutObligationsRouteWithChildren;
  '/_authLayout/on-logged': typeof AuthLayoutOnLoggedRoute;
  '/_authLayout/pfolio-settings': typeof AuthLayoutPfolioSettingsRoute;
  '/_authLayout/portfolios': typeof AuthLayoutPortfoliosRoute;
  '/_authLayout/settings': typeof AuthLayoutSettingsRoute;
  '/_authLayout/settings-member': typeof AuthLayoutSettingsMemberRoute;
  '/_authLayout/sign-in': typeof AuthLayoutSignInRoute;
  '/_authLayout/user': typeof AuthLayoutUserRoute;
  '/sign-in/$': typeof SignInSplatRoute;
  '/sign-up/$': typeof SignUpSplatRoute;
  '/_authLayout/analytics/$fundId': typeof AuthLayoutAnalyticsFundIdRoute;
  '/_authLayout/analytics/upload': typeof AuthLayoutAnalyticsUploadRoute;
  '/_authLayout/company/$companyId': typeof AuthLayoutCompanyCompanyIdRoute;
  '/_authLayout/company/list': typeof AuthLayoutCompanyListRoute;
  '/_authLayout/dashboard/$dashboardId': typeof AuthLayoutDashboardDashboardIdRoute;
  '/_authLayout/debug/asset-breakdown': typeof AuthLayoutDebugAssetBreakdownRoute;
  '/_authLayout/debug/forward-returns': typeof AuthLayoutDebugForwardReturnsRoute;
  '/_authLayout/debug/widget': typeof AuthLayoutDebugWidgetRoute;
  '/_authLayout/documents/fund-create': typeof AuthLayoutDocumentsFundCreateRoute;
  '/_authLayout/fund/overview': typeof AuthLayoutFundOverviewRoute;
  '/_authLayout/popout/$widgetType': typeof AuthLayoutPopoutWidgetTypeRoute;
  '/_authLayout/portfolio-company/$portfolioId': typeof AuthLayoutPortfolioCompanyPortfolioIdRoute;
  '/_authLayout/portfolio/create': typeof AuthLayoutPortfolioCreateRoute;
  '/_authLayout/workflows/$workflowId': typeof AuthLayoutWorkflowsWorkflowIdRoute;
  '/_authLayout/workflows/': typeof AuthLayoutWorkflowsIndexRoute;
  '/_authLayout/documents/fund/$fundId': typeof AuthLayoutDocumentsFundFundIdRoute;
  '/_authLayout/documents/overview/$docId': typeof AuthLayoutDocumentsOverviewDocIdRoute;
  '/_authLayout/fund/portfolioCompanies/$fundId': typeof AuthLayoutFundPortfolioCompaniesFundIdRoute;
  '/_authLayout/obligations/list/$countryCode': typeof AuthLayoutObligationsListCountryCodeRoute;
  '/_authLayout/portfolio/$portfolioId/ai-recommendations': typeof AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute;
  '/_authLayout/portfolio/$portfolioId/analysis': typeof AuthLayoutPortfolioPortfolioIdAnalysisRoute;
  '/_authLayout/portfolio/$portfolioId/overview': typeof AuthLayoutPortfolioPortfolioIdOverviewRoute;
  '/_authLayout/portfolio/$portfolioId/risks': typeof AuthLayoutPortfolioPortfolioIdRisksRoute;
  '/_authLayout/portfolio/$portfolioId/upload': typeof AuthLayoutPortfolioPortfolioIdUploadRoute;
  '/_authLayout/obligations/clause/$documentId/$clauseId': typeof AuthLayoutObligationsClauseDocumentIdClauseIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/analytics'
    | '/documents'
    | '/no-dashboards'
    | '/no-portfolios'
    | '/obligations'
    | '/on-logged'
    | '/pfolio-settings'
    | '/portfolios'
    | '/settings'
    | '/settings-member'
    | '/sign-in'
    | '/user'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/analytics/$fundId'
    | '/analytics/upload'
    | '/company/$companyId'
    | '/company/list'
    | '/dashboard/$dashboardId'
    | '/debug/asset-breakdown'
    | '/debug/forward-returns'
    | '/debug/widget'
    | '/documents/fund-create'
    | '/fund/overview'
    | '/popout/$widgetType'
    | '/portfolio-company/$portfolioId'
    | '/portfolio/create'
    | '/workflows/$workflowId'
    | '/workflows/'
    | '/documents/fund/$fundId'
    | '/documents/overview/$docId'
    | '/fund/portfolioCompanies/$fundId'
    | '/obligations/list/$countryCode'
    | '/portfolio/$portfolioId/ai-recommendations'
    | '/portfolio/$portfolioId/analysis'
    | '/portfolio/$portfolioId/overview'
    | '/portfolio/$portfolioId/risks'
    | '/portfolio/$portfolioId/upload'
    | '/obligations/clause/$documentId/$clauseId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/analytics'
    | '/documents'
    | '/no-dashboards'
    | '/no-portfolios'
    | '/obligations'
    | '/on-logged'
    | '/pfolio-settings'
    | '/portfolios'
    | '/settings'
    | '/settings-member'
    | '/sign-in'
    | '/user'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/analytics/$fundId'
    | '/analytics/upload'
    | '/company/$companyId'
    | '/company/list'
    | '/dashboard/$dashboardId'
    | '/debug/asset-breakdown'
    | '/debug/forward-returns'
    | '/debug/widget'
    | '/documents/fund-create'
    | '/fund/overview'
    | '/popout/$widgetType'
    | '/portfolio-company/$portfolioId'
    | '/portfolio/create'
    | '/workflows/$workflowId'
    | '/workflows'
    | '/documents/fund/$fundId'
    | '/documents/overview/$docId'
    | '/fund/portfolioCompanies/$fundId'
    | '/obligations/list/$countryCode'
    | '/portfolio/$portfolioId/ai-recommendations'
    | '/portfolio/$portfolioId/analysis'
    | '/portfolio/$portfolioId/overview'
    | '/portfolio/$portfolioId/risks'
    | '/portfolio/$portfolioId/upload'
    | '/obligations/clause/$documentId/$clauseId';
  id:
    | '__root__'
    | '/'
    | '/_authLayout'
    | '/_authLayout/analytics'
    | '/_authLayout/documents'
    | '/_authLayout/no-dashboards'
    | '/_authLayout/no-portfolios'
    | '/_authLayout/obligations'
    | '/_authLayout/on-logged'
    | '/_authLayout/pfolio-settings'
    | '/_authLayout/portfolios'
    | '/_authLayout/settings'
    | '/_authLayout/settings-member'
    | '/_authLayout/sign-in'
    | '/_authLayout/user'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/_authLayout/analytics/$fundId'
    | '/_authLayout/analytics/upload'
    | '/_authLayout/company/$companyId'
    | '/_authLayout/company/list'
    | '/_authLayout/dashboard/$dashboardId'
    | '/_authLayout/debug/asset-breakdown'
    | '/_authLayout/debug/forward-returns'
    | '/_authLayout/debug/widget'
    | '/_authLayout/documents/fund-create'
    | '/_authLayout/fund/overview'
    | '/_authLayout/popout/$widgetType'
    | '/_authLayout/portfolio-company/$portfolioId'
    | '/_authLayout/portfolio/create'
    | '/_authLayout/workflows/$workflowId'
    | '/_authLayout/workflows/'
    | '/_authLayout/documents/fund/$fundId'
    | '/_authLayout/documents/overview/$docId'
    | '/_authLayout/fund/portfolioCompanies/$fundId'
    | '/_authLayout/obligations/list/$countryCode'
    | '/_authLayout/portfolio/$portfolioId/ai-recommendations'
    | '/_authLayout/portfolio/$portfolioId/analysis'
    | '/_authLayout/portfolio/$portfolioId/overview'
    | '/_authLayout/portfolio/$portfolioId/risks'
    | '/_authLayout/portfolio/$portfolioId/upload'
    | '/_authLayout/obligations/clause/$documentId/$clauseId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren;
  SignInSplatRoute: typeof SignInSplatRoute;
  SignUpSplatRoute: typeof SignUpSplatRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authLayout': {
      id: '/_authLayout';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthLayoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sign-up/$': {
      id: '/sign-up/$';
      path: '/sign-up/$';
      fullPath: '/sign-up/$';
      preLoaderRoute: typeof SignUpSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sign-in/$': {
      id: '/sign-in/$';
      path: '/sign-in/$';
      fullPath: '/sign-in/$';
      preLoaderRoute: typeof SignInSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authLayout/user': {
      id: '/_authLayout/user';
      path: '/user';
      fullPath: '/user';
      preLoaderRoute: typeof AuthLayoutUserRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/sign-in': {
      id: '/_authLayout/sign-in';
      path: '/sign-in';
      fullPath: '/sign-in';
      preLoaderRoute: typeof AuthLayoutSignInRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/settings-member': {
      id: '/_authLayout/settings-member';
      path: '/settings-member';
      fullPath: '/settings-member';
      preLoaderRoute: typeof AuthLayoutSettingsMemberRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/settings': {
      id: '/_authLayout/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AuthLayoutSettingsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/portfolios': {
      id: '/_authLayout/portfolios';
      path: '/portfolios';
      fullPath: '/portfolios';
      preLoaderRoute: typeof AuthLayoutPortfoliosRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/pfolio-settings': {
      id: '/_authLayout/pfolio-settings';
      path: '/pfolio-settings';
      fullPath: '/pfolio-settings';
      preLoaderRoute: typeof AuthLayoutPfolioSettingsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/on-logged': {
      id: '/_authLayout/on-logged';
      path: '/on-logged';
      fullPath: '/on-logged';
      preLoaderRoute: typeof AuthLayoutOnLoggedRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/obligations': {
      id: '/_authLayout/obligations';
      path: '/obligations';
      fullPath: '/obligations';
      preLoaderRoute: typeof AuthLayoutObligationsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/no-portfolios': {
      id: '/_authLayout/no-portfolios';
      path: '/no-portfolios';
      fullPath: '/no-portfolios';
      preLoaderRoute: typeof AuthLayoutNoPortfoliosRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/no-dashboards': {
      id: '/_authLayout/no-dashboards';
      path: '/no-dashboards';
      fullPath: '/no-dashboards';
      preLoaderRoute: typeof AuthLayoutNoDashboardsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/documents': {
      id: '/_authLayout/documents';
      path: '/documents';
      fullPath: '/documents';
      preLoaderRoute: typeof AuthLayoutDocumentsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/analytics': {
      id: '/_authLayout/analytics';
      path: '/analytics';
      fullPath: '/analytics';
      preLoaderRoute: typeof AuthLayoutAnalyticsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/workflows/': {
      id: '/_authLayout/workflows/';
      path: '/workflows';
      fullPath: '/workflows/';
      preLoaderRoute: typeof AuthLayoutWorkflowsIndexRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/workflows/$workflowId': {
      id: '/_authLayout/workflows/$workflowId';
      path: '/workflows/$workflowId';
      fullPath: '/workflows/$workflowId';
      preLoaderRoute: typeof AuthLayoutWorkflowsWorkflowIdRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/portfolio/create': {
      id: '/_authLayout/portfolio/create';
      path: '/portfolio/create';
      fullPath: '/portfolio/create';
      preLoaderRoute: typeof AuthLayoutPortfolioCreateRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/portfolio-company/$portfolioId': {
      id: '/_authLayout/portfolio-company/$portfolioId';
      path: '/portfolio-company/$portfolioId';
      fullPath: '/portfolio-company/$portfolioId';
      preLoaderRoute: typeof AuthLayoutPortfolioCompanyPortfolioIdRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/popout/$widgetType': {
      id: '/_authLayout/popout/$widgetType';
      path: '/popout/$widgetType';
      fullPath: '/popout/$widgetType';
      preLoaderRoute: typeof AuthLayoutPopoutWidgetTypeRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/fund/overview': {
      id: '/_authLayout/fund/overview';
      path: '/fund/overview';
      fullPath: '/fund/overview';
      preLoaderRoute: typeof AuthLayoutFundOverviewRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/documents/fund-create': {
      id: '/_authLayout/documents/fund-create';
      path: '/fund-create';
      fullPath: '/documents/fund-create';
      preLoaderRoute: typeof AuthLayoutDocumentsFundCreateRouteImport;
      parentRoute: typeof AuthLayoutDocumentsRoute;
    };
    '/_authLayout/debug/widget': {
      id: '/_authLayout/debug/widget';
      path: '/debug/widget';
      fullPath: '/debug/widget';
      preLoaderRoute: typeof AuthLayoutDebugWidgetRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/debug/forward-returns': {
      id: '/_authLayout/debug/forward-returns';
      path: '/debug/forward-returns';
      fullPath: '/debug/forward-returns';
      preLoaderRoute: typeof AuthLayoutDebugForwardReturnsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/debug/asset-breakdown': {
      id: '/_authLayout/debug/asset-breakdown';
      path: '/debug/asset-breakdown';
      fullPath: '/debug/asset-breakdown';
      preLoaderRoute: typeof AuthLayoutDebugAssetBreakdownRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/dashboard/$dashboardId': {
      id: '/_authLayout/dashboard/$dashboardId';
      path: '/dashboard/$dashboardId';
      fullPath: '/dashboard/$dashboardId';
      preLoaderRoute: typeof AuthLayoutDashboardDashboardIdRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/company/list': {
      id: '/_authLayout/company/list';
      path: '/company/list';
      fullPath: '/company/list';
      preLoaderRoute: typeof AuthLayoutCompanyListRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/company/$companyId': {
      id: '/_authLayout/company/$companyId';
      path: '/company/$companyId';
      fullPath: '/company/$companyId';
      preLoaderRoute: typeof AuthLayoutCompanyCompanyIdRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/analytics/upload': {
      id: '/_authLayout/analytics/upload';
      path: '/upload';
      fullPath: '/analytics/upload';
      preLoaderRoute: typeof AuthLayoutAnalyticsUploadRouteImport;
      parentRoute: typeof AuthLayoutAnalyticsRoute;
    };
    '/_authLayout/analytics/$fundId': {
      id: '/_authLayout/analytics/$fundId';
      path: '/$fundId';
      fullPath: '/analytics/$fundId';
      preLoaderRoute: typeof AuthLayoutAnalyticsFundIdRouteImport;
      parentRoute: typeof AuthLayoutAnalyticsRoute;
    };
    '/_authLayout/portfolio/$portfolioId/upload': {
      id: '/_authLayout/portfolio/$portfolioId/upload';
      path: '/portfolio/$portfolioId/upload';
      fullPath: '/portfolio/$portfolioId/upload';
      preLoaderRoute: typeof AuthLayoutPortfolioPortfolioIdUploadRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/portfolio/$portfolioId/risks': {
      id: '/_authLayout/portfolio/$portfolioId/risks';
      path: '/portfolio/$portfolioId/risks';
      fullPath: '/portfolio/$portfolioId/risks';
      preLoaderRoute: typeof AuthLayoutPortfolioPortfolioIdRisksRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/portfolio/$portfolioId/overview': {
      id: '/_authLayout/portfolio/$portfolioId/overview';
      path: '/portfolio/$portfolioId/overview';
      fullPath: '/portfolio/$portfolioId/overview';
      preLoaderRoute: typeof AuthLayoutPortfolioPortfolioIdOverviewRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/portfolio/$portfolioId/analysis': {
      id: '/_authLayout/portfolio/$portfolioId/analysis';
      path: '/portfolio/$portfolioId/analysis';
      fullPath: '/portfolio/$portfolioId/analysis';
      preLoaderRoute: typeof AuthLayoutPortfolioPortfolioIdAnalysisRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/portfolio/$portfolioId/ai-recommendations': {
      id: '/_authLayout/portfolio/$portfolioId/ai-recommendations';
      path: '/portfolio/$portfolioId/ai-recommendations';
      fullPath: '/portfolio/$portfolioId/ai-recommendations';
      preLoaderRoute: typeof AuthLayoutPortfolioPortfolioIdAiRecommendationsRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/obligations/list/$countryCode': {
      id: '/_authLayout/obligations/list/$countryCode';
      path: '/list/$countryCode';
      fullPath: '/obligations/list/$countryCode';
      preLoaderRoute: typeof AuthLayoutObligationsListCountryCodeRouteImport;
      parentRoute: typeof AuthLayoutObligationsRoute;
    };
    '/_authLayout/fund/portfolioCompanies/$fundId': {
      id: '/_authLayout/fund/portfolioCompanies/$fundId';
      path: '/fund/portfolioCompanies/$fundId';
      fullPath: '/fund/portfolioCompanies/$fundId';
      preLoaderRoute: typeof AuthLayoutFundPortfolioCompaniesFundIdRouteImport;
      parentRoute: typeof AuthLayoutRoute;
    };
    '/_authLayout/documents/overview/$docId': {
      id: '/_authLayout/documents/overview/$docId';
      path: '/overview/$docId';
      fullPath: '/documents/overview/$docId';
      preLoaderRoute: typeof AuthLayoutDocumentsOverviewDocIdRouteImport;
      parentRoute: typeof AuthLayoutDocumentsRoute;
    };
    '/_authLayout/documents/fund/$fundId': {
      id: '/_authLayout/documents/fund/$fundId';
      path: '/fund/$fundId';
      fullPath: '/documents/fund/$fundId';
      preLoaderRoute: typeof AuthLayoutDocumentsFundFundIdRouteImport;
      parentRoute: typeof AuthLayoutDocumentsRoute;
    };
    '/_authLayout/obligations/clause/$documentId/$clauseId': {
      id: '/_authLayout/obligations/clause/$documentId/$clauseId';
      path: '/clause/$documentId/$clauseId';
      fullPath: '/obligations/clause/$documentId/$clauseId';
      preLoaderRoute: typeof AuthLayoutObligationsClauseDocumentIdClauseIdRouteImport;
      parentRoute: typeof AuthLayoutObligationsRoute;
    };
  }
}

interface AuthLayoutAnalyticsRouteChildren {
  AuthLayoutAnalyticsFundIdRoute: typeof AuthLayoutAnalyticsFundIdRoute;
  AuthLayoutAnalyticsUploadRoute: typeof AuthLayoutAnalyticsUploadRoute;
}

const AuthLayoutAnalyticsRouteChildren: AuthLayoutAnalyticsRouteChildren = {
  AuthLayoutAnalyticsFundIdRoute: AuthLayoutAnalyticsFundIdRoute,
  AuthLayoutAnalyticsUploadRoute: AuthLayoutAnalyticsUploadRoute,
};

const AuthLayoutAnalyticsRouteWithChildren =
  AuthLayoutAnalyticsRoute._addFileChildren(AuthLayoutAnalyticsRouteChildren);

interface AuthLayoutDocumentsRouteChildren {
  AuthLayoutDocumentsFundCreateRoute: typeof AuthLayoutDocumentsFundCreateRoute;
  AuthLayoutDocumentsFundFundIdRoute: typeof AuthLayoutDocumentsFundFundIdRoute;
  AuthLayoutDocumentsOverviewDocIdRoute: typeof AuthLayoutDocumentsOverviewDocIdRoute;
}

const AuthLayoutDocumentsRouteChildren: AuthLayoutDocumentsRouteChildren = {
  AuthLayoutDocumentsFundCreateRoute: AuthLayoutDocumentsFundCreateRoute,
  AuthLayoutDocumentsFundFundIdRoute: AuthLayoutDocumentsFundFundIdRoute,
  AuthLayoutDocumentsOverviewDocIdRoute: AuthLayoutDocumentsOverviewDocIdRoute,
};

const AuthLayoutDocumentsRouteWithChildren =
  AuthLayoutDocumentsRoute._addFileChildren(AuthLayoutDocumentsRouteChildren);

interface AuthLayoutObligationsRouteChildren {
  AuthLayoutObligationsListCountryCodeRoute: typeof AuthLayoutObligationsListCountryCodeRoute;
  AuthLayoutObligationsClauseDocumentIdClauseIdRoute: typeof AuthLayoutObligationsClauseDocumentIdClauseIdRoute;
}

const AuthLayoutObligationsRouteChildren: AuthLayoutObligationsRouteChildren = {
  AuthLayoutObligationsListCountryCodeRoute:
    AuthLayoutObligationsListCountryCodeRoute,
  AuthLayoutObligationsClauseDocumentIdClauseIdRoute:
    AuthLayoutObligationsClauseDocumentIdClauseIdRoute,
};

const AuthLayoutObligationsRouteWithChildren =
  AuthLayoutObligationsRoute._addFileChildren(
    AuthLayoutObligationsRouteChildren,
  );

interface AuthLayoutRouteChildren {
  AuthLayoutAnalyticsRoute: typeof AuthLayoutAnalyticsRouteWithChildren;
  AuthLayoutDocumentsRoute: typeof AuthLayoutDocumentsRouteWithChildren;
  AuthLayoutNoDashboardsRoute: typeof AuthLayoutNoDashboardsRoute;
  AuthLayoutNoPortfoliosRoute: typeof AuthLayoutNoPortfoliosRoute;
  AuthLayoutObligationsRoute: typeof AuthLayoutObligationsRouteWithChildren;
  AuthLayoutOnLoggedRoute: typeof AuthLayoutOnLoggedRoute;
  AuthLayoutPfolioSettingsRoute: typeof AuthLayoutPfolioSettingsRoute;
  AuthLayoutPortfoliosRoute: typeof AuthLayoutPortfoliosRoute;
  AuthLayoutSettingsRoute: typeof AuthLayoutSettingsRoute;
  AuthLayoutSettingsMemberRoute: typeof AuthLayoutSettingsMemberRoute;
  AuthLayoutSignInRoute: typeof AuthLayoutSignInRoute;
  AuthLayoutUserRoute: typeof AuthLayoutUserRoute;
  AuthLayoutCompanyCompanyIdRoute: typeof AuthLayoutCompanyCompanyIdRoute;
  AuthLayoutCompanyListRoute: typeof AuthLayoutCompanyListRoute;
  AuthLayoutDashboardDashboardIdRoute: typeof AuthLayoutDashboardDashboardIdRoute;
  AuthLayoutDebugAssetBreakdownRoute: typeof AuthLayoutDebugAssetBreakdownRoute;
  AuthLayoutDebugForwardReturnsRoute: typeof AuthLayoutDebugForwardReturnsRoute;
  AuthLayoutDebugWidgetRoute: typeof AuthLayoutDebugWidgetRoute;
  AuthLayoutFundOverviewRoute: typeof AuthLayoutFundOverviewRoute;
  AuthLayoutPopoutWidgetTypeRoute: typeof AuthLayoutPopoutWidgetTypeRoute;
  AuthLayoutPortfolioCompanyPortfolioIdRoute: typeof AuthLayoutPortfolioCompanyPortfolioIdRoute;
  AuthLayoutPortfolioCreateRoute: typeof AuthLayoutPortfolioCreateRoute;
  AuthLayoutWorkflowsWorkflowIdRoute: typeof AuthLayoutWorkflowsWorkflowIdRoute;
  AuthLayoutWorkflowsIndexRoute: typeof AuthLayoutWorkflowsIndexRoute;
  AuthLayoutFundPortfolioCompaniesFundIdRoute: typeof AuthLayoutFundPortfolioCompaniesFundIdRoute;
  AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute: typeof AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute;
  AuthLayoutPortfolioPortfolioIdAnalysisRoute: typeof AuthLayoutPortfolioPortfolioIdAnalysisRoute;
  AuthLayoutPortfolioPortfolioIdOverviewRoute: typeof AuthLayoutPortfolioPortfolioIdOverviewRoute;
  AuthLayoutPortfolioPortfolioIdRisksRoute: typeof AuthLayoutPortfolioPortfolioIdRisksRoute;
  AuthLayoutPortfolioPortfolioIdUploadRoute: typeof AuthLayoutPortfolioPortfolioIdUploadRoute;
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutAnalyticsRoute: AuthLayoutAnalyticsRouteWithChildren,
  AuthLayoutDocumentsRoute: AuthLayoutDocumentsRouteWithChildren,
  AuthLayoutNoDashboardsRoute: AuthLayoutNoDashboardsRoute,
  AuthLayoutNoPortfoliosRoute: AuthLayoutNoPortfoliosRoute,
  AuthLayoutObligationsRoute: AuthLayoutObligationsRouteWithChildren,
  AuthLayoutOnLoggedRoute: AuthLayoutOnLoggedRoute,
  AuthLayoutPfolioSettingsRoute: AuthLayoutPfolioSettingsRoute,
  AuthLayoutPortfoliosRoute: AuthLayoutPortfoliosRoute,
  AuthLayoutSettingsRoute: AuthLayoutSettingsRoute,
  AuthLayoutSettingsMemberRoute: AuthLayoutSettingsMemberRoute,
  AuthLayoutSignInRoute: AuthLayoutSignInRoute,
  AuthLayoutUserRoute: AuthLayoutUserRoute,
  AuthLayoutCompanyCompanyIdRoute: AuthLayoutCompanyCompanyIdRoute,
  AuthLayoutCompanyListRoute: AuthLayoutCompanyListRoute,
  AuthLayoutDashboardDashboardIdRoute: AuthLayoutDashboardDashboardIdRoute,
  AuthLayoutDebugAssetBreakdownRoute: AuthLayoutDebugAssetBreakdownRoute,
  AuthLayoutDebugForwardReturnsRoute: AuthLayoutDebugForwardReturnsRoute,
  AuthLayoutDebugWidgetRoute: AuthLayoutDebugWidgetRoute,
  AuthLayoutFundOverviewRoute: AuthLayoutFundOverviewRoute,
  AuthLayoutPopoutWidgetTypeRoute: AuthLayoutPopoutWidgetTypeRoute,
  AuthLayoutPortfolioCompanyPortfolioIdRoute:
    AuthLayoutPortfolioCompanyPortfolioIdRoute,
  AuthLayoutPortfolioCreateRoute: AuthLayoutPortfolioCreateRoute,
  AuthLayoutWorkflowsWorkflowIdRoute: AuthLayoutWorkflowsWorkflowIdRoute,
  AuthLayoutWorkflowsIndexRoute: AuthLayoutWorkflowsIndexRoute,
  AuthLayoutFundPortfolioCompaniesFundIdRoute:
    AuthLayoutFundPortfolioCompaniesFundIdRoute,
  AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute:
    AuthLayoutPortfolioPortfolioIdAiRecommendationsRoute,
  AuthLayoutPortfolioPortfolioIdAnalysisRoute:
    AuthLayoutPortfolioPortfolioIdAnalysisRoute,
  AuthLayoutPortfolioPortfolioIdOverviewRoute:
    AuthLayoutPortfolioPortfolioIdOverviewRoute,
  AuthLayoutPortfolioPortfolioIdRisksRoute:
    AuthLayoutPortfolioPortfolioIdRisksRoute,
  AuthLayoutPortfolioPortfolioIdUploadRoute:
    AuthLayoutPortfolioPortfolioIdUploadRoute,
};

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  SignInSplatRoute: SignInSplatRoute,
  SignUpSplatRoute: SignUpSplatRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
